import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { CommonRoutePathsEnum } from '@/modules/common/routes/commonRouteConfig.types'
import type { LoginLocationState } from '@/modules/login/routes/loginRouteConfig.types'

import { useUserStore } from '@/store/user.store'

import type { role } from '@/__generated__/requests'

import { getUserDefaultPath } from '@/helpers/getUserDefaultPath.helper'

export function RoleChecker({ roles = [] }: { roles: role[] }) {
  const user = useUserStore.use.user()
  const currentRole = useUserStore.use.currentRole()
  const location = useLocation()

  if (
    !user ||
    !roles.length ||
    roles.some(role => user.roles?.includes(role))
  ) {
    return <Outlet />
  }

  const { fromLogin } = (location.state as LoginLocationState | null) ?? {}

  if (fromLogin) {
    return <Navigate replace to={getUserDefaultPath(user, currentRole)} />
  }

  return <Navigate to={CommonRoutePathsEnum.REDIRECTED_TO_NOT_FOUND} />
}
